import { ProtectedRoute, TranslationBreadcrumb } from "components/UI";
import { Accounting, AccountingSuccess } from "./pages";

const accountingRoutes = [
  {
    path: "/accounting",
    element: (
      <ProtectedRoute isNotEmployee>
        <Accounting />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="accounting" />,
  },
  {
    path: "/accounting/success",
    element: (
      <ProtectedRoute isNotEmployee>
        <AccountingSuccess />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="accounting" />,
  },
];

export default accountingRoutes;
